import { render, staticRenderFns } from "./TagDescription.vue?vue&type=template&id=9d8b2c2c"
import script from "./TagDescription.vue?vue&type=script&lang=ts"
export * from "./TagDescription.vue?vue&type=script&lang=ts"
import style0 from "./TagDescription.vue?vue&type=style&index=0&id=9d8b2c2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports